import { TaskContext } from '../components/organism.task/context.js';
import { ResultsPieChart } from '../page.results/atom.pie-chart/_pie-chart.js';
import { PrintTaskSummary } from '../page.results/molecule.task-accordion/molecule.summary.js';
import { useOpgavekompleksetComponent } from '../state/context.data.js';
import { useOpgavekompleksetEntry } from '../state/hook.entry.js';
import { shouldShowReport } from '../state/util.should-show-report.js';
import { PrintTasksHeader } from './molecule.tasks-header.js';
import { page, meta, headingWrapper, label, heading, pieWrapper, contentWrapper, tasksWrapper } from './page.overview.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function PrintOverviewPage() {
  const component = useOpgavekompleksetComponent();
  const hasFinsihedEntry = useOpgavekompleksetEntry({
    select: entry => !entry ? false : entry.envelope.result?.status === "completed"
  });
  return /*#__PURE__*/jsxs("div", {
    className: page,
    children: [/*#__PURE__*/jsxs("div", {
      className: meta,
      children: [/*#__PURE__*/jsxs("div", {
        className: headingWrapper,
        children: [/*#__PURE__*/jsx("div", {
          className: label,
          children: "Resultater fra opgaves\xE6ttet:"
        }), /*#__PURE__*/jsx("b", {
          className: heading,
          children: component.envelope.Title
        })]
      }), /*#__PURE__*/jsx("div", {
        className: pieWrapper,
        children: /*#__PURE__*/jsx(ResultsPieChart, {
          context: "print"
        })
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: contentWrapper,
      children: [/*#__PURE__*/jsx(PrintTasksHeader, {}), /*#__PURE__*/jsx("div", {
        className: tasksWrapper,
        children: /*#__PURE__*/jsx(TaskContext.Provider, {
          value: hasFinsihedEntry ? shouldShowReport(component.data.settings.flowType) ? "facit" : "readonly" : "input",
          children: component.data.tasks
          // We omit infopages from the results, See ADO #114226
          .filter(task => task.type !== "task" || task.taskType !== "InfoPage").map((task, index) => /*#__PURE__*/jsx(PrintTaskSummary, {
            index: index,
            task: task
          }, task.id))
        })
      })]
    })]
  });
}

export { PrintOverviewPage };
//# sourceMappingURL=page.overview.js.map
